import { useCallback, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import IconGoogle from 'src/assets/icons/Google';
import {
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';
import { getQueryParamValue } from 'src/lib/browser';
import { getDeviceType } from 'src/lib/userAgent';
import { loginToGoogle } from 'src/utils/lib/oauth';

import { useStyles } from './useStyles';

const prepareState = () => {
  const result = {
    request_origin: window.location.origin,
  };

  const referralToken = getQueryParamValue('invite');
  if (referralToken) {
    result.referral_token = referralToken;
  }

  return JSON.stringify(result);
};

const OAuthPanel = ({ className, label, loading, disabled, onStart, onSuccess, onError }) => {
  const styles = useStyles();

  const [processing, setProcessing] = useState(false);

  const handleGoogle = useCallback(() => {
    setProcessing(true);
    onStart();

    const state = prepareState();
    const signUpDevice = getDeviceType();

    loginToGoogle(state, signUpDevice)
      .then(({ token, wasUserCreated }) => {
        setProcessing(false);
        onSuccess({ token, wasUserCreated });
      })
      .catch((e) => {
        setProcessing(false);
        onError(e);
      });
  }, [onStart, onSuccess, onError]);

  return (
    <CustomButton
      className={cx(styles.root, className)}
      loading={loading || processing}
      disabled={disabled || loading || processing}
      onClick={handleGoogle}
      startIcon={<IconGoogle className={styles.icon} />}
      variant={CUSTOM_BUTTON_VARIANT.outlined}
      size={CUSTOM_BUTTON_SIZE.medium}
      data-testid="OAuthPanel__Button"
      fullWidth
    >
      {label || 'Continue with Google'}
    </CustomButton>
  );
};

OAuthPanel.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onStart: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};
OAuthPanel.defaultProps = {
  className: null,
  label: null,
  loading: false,
  disabled: false,
};

export default OAuthPanel;
